module.exports = __webpack_public_path__ + "static/media/geo-01.06b529e0.svg";